import excelTemplate from "../../../assets/Zet-Customer-Sheet-Sample.csv";
import csvScenarioP0001 from "../../../assets/csvsamples/Zet_smaple_P0001_Flow.csv";
import csvScenarioP0002 from "../../../assets/csvsamples/Zet_smaple_P0002_Flow.csv";
import csvScenarioP0003 from "../../../assets/csvsamples/Zet_sample_Magnet_Retargeting_P0003_Flow.csv";
import csvScenarioP0004 from "../../../assets/csvsamples/Zet_sample_Magnet_Week_P0004_Flow.csv";
import csvScenarioP0005 from "../../../assets/csvsamples/Zet_sample_Magnet_Month_P0005_Flow.csv";
import csvScenarioP0006 from "../../../assets/csvsamples/Zet_sample_Improve Credit Score Consent_P0006_Flow.csv";
import csvScenarioP0007 from "../../../assets/csvsamples/Zet_sample_P0007_Flow_Soft Churn and Hard Churn Agent Brand Re-activation.csv";
import csvScenarioP0008 from "../../../assets/csvsamples/Zet_sample_P0008_Flow_Soft Churn ndHard Churn Agent New Brand.csv";
import csvScenarioP0009 from "../../../assets/csvsamples/Zet_sample_P0009_Flow_Soft Churn and Hard Churn Agent Approval Rate.csv";
import csvScenarioP00010 from "../../../assets/csvsamples/Zet_sample_P00010_Flow_Magnet Week New.csv";
import csvScenarioP00011 from "../../../assets/csvsamples/Zet_sample_P00011_Flow_Magnet Week Round 2.csv";
import csvScenarioP00012 from "../../../assets/csvsamples/Zet_sample_P00012_Flow_Magnet Week FOMO.csv";
import csvScenarioP00013 from "../../../assets/csvsamples/Zet_sample_P00013_Flow_Priority Agent.csv";
import csvScenarioP00014 from "../../../assets/csvsamples/Zet_sample_P00014_Flow_Magnet Sales End Customer.csv";
import csvScenarioP00015 from "../../../assets/csvsamples/Zet_sample_P00015_AU Activation Customer.csv";
import csvScenarioP00016 from "../../../assets/csvsamples/Zet_sample_P00016_HSBC Activation Customer.csv";
import csvScenarioP00017 from "../../../assets/csvsamples/Zet_sample_P00017_HDFC Activation Customer.csv";
import csvScenarioP00018 from "../../../assets/csvsamples/Zet_sample_P00018_Magnet customer to customer referral.csv";
import csvScenarioP00019 from "../../../assets/csvsamples/Zet_sample_P00019_Magnet Week  Intro July.csv";
import csvScenarioP00020 from "../../../assets/csvsamples/Zet_sample_P00020_Magnet Week  FOMO July.csv";
import csvScenarioP00021 from "../../../assets/csvsamples/Zet_sample_P00021_Magnet Week Offer  Extension July.csv";
import csvScenarioP00022 from "../../../assets/csvsamples/Zet_sample_P00022_Flow_New Categories on ZET Partner.csv";
import csvScenarioP00023 from "../../../assets/csvsamples/Zet_sample_P00023_Flow_Magnet Sales Bonus ZET Partner.csv";
import csvScenarioP00024 from "../../../assets/csvsamples/Zet_sample_P00024_Flow_ZET Partner Referral Championship Program.csv";
import csvScenarioP00025 from "../../../assets/csvsamples/Zet_sample_P00025_Flow_Credit Mahotsav ZET Partner.csv";
import csvScenarioP00026 from "../../../assets/csvsamples/Zet_sample_P00026_Credit Mahotsav ZET Partner Second.csv";
import csvScenarioP00027 from "../../../assets/csvsamples/Zet_sample_P00027_Saving Dhamaka Offer FOMO.csv";
import csvScenarioP00028 from "../../../assets/csvsamples/Zet_sample_P00028_Flow_Magnet Bonanza Week.csv";
import csvScenarioP00029 from "../../../assets/csvsamples/Zet_sample_P00029_Flow_Loan Mahotsav.csv";
import csvScenarioP00030 from "../../../assets/csvsamples/Zet_sample_P00030_Flow_ZET Partner Magnet New Year Sale.csv";
import csvScenarioP00031 from "../../../assets/csvsamples/Bharti axa Pre due Flow P00031.csv";
import csvScenarioP00032 from "../../../assets/csvsamples/Bharti axa Flow P00032.csv";
import csvScenarioP00033 from "../../../assets/csvsamples/Edelweiss Flow P00033.csv";
// import csvScenarioP00034 from "../../../assets/csvsamples/Edelweiss Flow v2 P00034.csv"; 
import csvScenarioP00034 from "../../../assets/csvsamples/IndiaFirst Post Due P00034 Flow.csv"; 
import csvScenarioP00035 from "../../../assets/csvsamples/IndiaFirst Post Due P00035 Flow.csv"; 
import csvScenarioP00036 from "../../../assets/csvsamples/IndiaFirst Pre Due P00036 Flow.csv"; 

export const s_time = [
  { valueUTC: "10:00 AM", title: "10:00 AM" },
  { valueUTC: "10:30 AM", title: "10:30 AM" },
  { valueUTC: "11:00 AM", title: "11:00 AM" },
  { valueUTC: "11:30 AM", title: "11:30 AM" },
  { valueUTC: "12:00 PM", title: "12:00 PM" },
  { valueUTC: "12:30 PM", title: "12:30 PM" },
  { valueUTC: "01:00 PM", title: "01:00 PM" },
  { valueUTC: "01:30 AM", title: "01:30 AM" },
  { valueUTC: "02:00 PM", title: "02:00 PM" },
];
export const wfDetails = [
  // {
  //   name: "Zet Scenario Id 1 (P0001)",
  //   id: "P0001",
  //   templateUrl: csvScenarioP0001,
  // },
  // {
  //   name: "Zet Scenario Id 2 (P0002)",
  //   id: "P0002",
  //   templateUrl: csvScenarioP0002,
  // },
  // {
  //   name: "Magnet Retargeting (P0003)",
  //   id: "P0003",
  //   templateUrl: csvScenarioP0003,
  // },
  // {
  //   name: "Magnet Week (P0004)",
  //   id: "P0004",
  //   templateUrl: csvScenarioP0004,
  // },
  // {
  //   name: "Magnet Month (P0005)",
  //   id: "P0005",
  //   templateUrl: csvScenarioP0005,
  // },
  // {
  //   name: "Improve Credit Score Consent (P0006)",
  //   id: "P0006",
  //   templateUrl: csvScenarioP0006,
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: Brand Re-activation (P0007)",
  //   id: "P0007",
  //   templateUrl: csvScenarioP0007,
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: New Brand (P0008)",
  //   id: "P0008",
  //   templateUrl: csvScenarioP0008,
  // },
  // {
  //   name: "Soft Churn and Hard Churn Agent: Approval Rate (P0009)",
  //   id: "P0009",
  //   templateUrl: csvScenarioP0009,
  // },
  // {
  //   name: "Magnet Week New (P00010)",
  //   id: "P00010",
  //   templateUrl: csvScenarioP00010,
  // },
  // {
  //   name: "Magnet Week: Round 2 (P00011)",
  //   id: "P00011",
  //   templateUrl: csvScenarioP00011,
  // },
  // {
  //   name: "Magnet Week: FOMO (P00012)",
  //   id: "P00012",
  //   templateUrl: csvScenarioP00012,
  // },
  // {
  //   name: "Priority Agent (P00013)",
  //   id: "P00013",
  //   templateUrl: csvScenarioP00013,
  // },
  // {
  //   name: "Magnet Sales: End Customer (P00014)",
  //   id: "P00014",
  //   templateUrl: csvScenarioP00014,
  // },
  // {
  //   name: "AU Activation Customer (P00015)",
  //   id: "P00015",
  //   templateUrl: csvScenarioP00015,
  // },
  // {
  //   name: "HSBC Activation Customer (P00016)",
  //   id: "P00016",
  //   templateUrl: csvScenarioP00016,
  // },
  // {
  //   name: "HDFC Activation Customer (P00017)",
  //   id: "P00017",
  //   templateUrl: csvScenarioP00017,
  // },
  // {
  //   name: "Magnet customer to customer referral (P00018)",
  //   id: "P00018",
  //   templateUrl: csvScenarioP00018,
  // },
  // {
  //   name: "Magnet Week : Intro July (P00019)",
  //   id: "P00019",
  //   templateUrl: csvScenarioP00019,
  // },
  // {
  //   name: "Magnet Week : FOMO July (P00020)",
  //   id: "P00020",
  //   templateUrl: csvScenarioP00020,
  // },
  // {
  //   name: "Magnet Week Offer : Extension July (P00021)",
  //   id: "P00021",
  //   templateUrl: csvScenarioP00021,
  // },
  // {
  //   name: "New Categories on ZET Partner (P00022)",
  //   id: "P00022",
  //   templateUrl: csvScenarioP00022,
  // },
  // {
  //   name: "Magnet Sales Bonus ZET Partner (P00023)",
  //   id: "P00023",
  //   templateUrl: csvScenarioP00023,
  // },
  // {
  //   name: "ZET Partner Referral Championship Program(P00024)",
  //   id: "P00024",
  //   templateUrl: csvScenarioP00024,
  // },
  // {
  //   name: "Credit Mahotsav ZET Partner (P00025)",
  //   id: "P00025",
  //   templateUrl: csvScenarioP00025,
  // },
  // {
  //   name: "Credit Mahotsav ZET Partner Second (P00026)",
  //   id: "P00026",
  //   templateUrl: csvScenarioP00026,
  // },
  // {
  //   name: "Saving Dhamaka Offer FOMO (P00027)",
  //   id: "P00027",
  //   templateUrl: csvScenarioP00027,
  // },
  // {
  //   name: "Magnet Bonanza Week (P00028)",
  //   id: "P00028",
  //   templateUrl: csvScenarioP00028,
  // },
  // {
  //   name: "Loan Mahotsav (P00029)",
  //   id: "P00029",
  //   templateUrl: csvScenarioP00029,
  // },

  // {
  //   name: "ZET Partner Magnet New Year Sale(P00030)",
  //   id: "P00030",
  //   templateUrl: csvScenarioP00030,
  // },
  // {
  //   name: "Bharti AXA ( Pre due ) (P00031)",
  //   id: "P00031",
  //   templateUrl: csvScenarioP00031,
  // },
  {
    name: "Bharati AXA (P00032)",
    id: "P00032",
    templateUrl: csvScenarioP00032,
  },
  {
    name: "Edelweiss (P00033)",
    id: "P00033",
    templateUrl: csvScenarioP00033,
  },
    {
    name: "IndiaFirst Post Due (P00034)",
    id: "P00034",
    templateUrl: csvScenarioP00034,
  },
  // {
  //   name: "Edelweiss Version 2(P00034)",
  //   id: "P00034",
  //   templateUrl: csvScenarioP00034,
  // },
  // {
  //   name: "IndiaFirst Post Due (P00035)",
  //   id: "P00035",
  //   templateUrl: csvScenarioP00035,
  // },
  //   {
  //   name: "IndiaFirst Pre Due (P00036)",
  //   id: "P00036",
  //   templateUrl: csvScenarioP00036,
  // },
];
export const columnName = [
  {
    Header: "File Name",
    accessor: "fileName",
  },
  {
    Header: "Upload timestamp",
    accessor: "uploadTimestamp",
  },
  {
    Header: "Admin Name",
    accessor: "uploaderName",
  },
  {
    Header: "Download",
    accessor: "download",
  },
  {
    Header: "WorkFlow",
    accessor: "workflowName",
  },
  {
    Header: "Batch Id",
    accessor: "id",
  },
  // {
  //   Header: "Status",
  //   accessor: "status",
  // },
  {
    Header: "Schedule Time",
    accessor: "scheduledTime",
  },
  {
    Header: "Call Initiation",
    accessor: "callInitiation",
  },
  // {
  //   Header: "Stop Call",
  //   accessor: "callCancellation",
  // },
  //above is real one
  // {
  //   Header: "Call Status",
  //   accessor: "callOnGoingStatus",
  // },
  {
    Header: "Call Reinitiation",
    accessor: "callReinitiation",
  },
  {
    Header: "More Details",
    accessor: "moreDetails",
  },
  {
    Header: "Disable File",
    accessor: "disableFile",
  },
];

export const tableData = [
  {
    fileName: "Customer data 17 Sept.csv",
    uploadTimestamp: "15 Sept 2023 10:30 AM",
    download: "",
    adminName: "sahoo.tusharkanta21@gmail.com",
    wfName: "CC-100",
    status: "processed",
    callInitiation: { data: "Start Call", visibility: true },
    sechduleTime: "21 Sept 2023 11:00 AM",
    enableStartCallButton: true,
  },
  {
    fileName: "Customer data  217 Sept.csv",
    uploadTimestamp: "15 Sept 2023 10:00 AM",
    uploadedFileName: "",
    download: "",
    adminName: "sahoo.tusharkanta21@gmail.com",
    wfName: "CC-100",
    status: "pending",
    callInitiation: { data: "Start Call", visibility: false },
    sechduleTime: "Set the call",
    enableStartCallButton: true,
  },
  {
    fileName: "Customer data  217 Sept.csv",
    uploadTimestamp: "15 Sept 2023 09:30 AM",
    uploadedFileName: "",
    download: "",
    adminName: "saheli@omkarainfotech.com",
    wfName: "CC-101",
    status: "processed",
    callInitiation: { data: "Start Call", visibility: true },
    sechduleTime: "Set the call",
    enableStartCallButton: false,
  },
  {
    fileName: "Customer data  217 Sept.csv",
    uploadTimestamp: "15 Sept 2023 09:30 AM",
    uploadedFileName: "",
    download: "",
    adminName: "saheli@omkarainfotech.com",
    wfName: "CC-101",
    status: "processed",
    callInitiation: { data: "Ongoing Call", visibility: true },
    sechduleTime: "20-Sept-2023 10:30 AM",
    enableStartCallButton: false,
  },
  {
    fileName: "Customer data  217 Sept.csv",
    uploadTimestamp: "15 Sept 2023 09:30 AM",
    uploadedFileName: "",
    download: "",
    adminName: "saheli@omkarainfotech.com",
    wfName: "CC-101",
    status: "processed",
    callInitiation: { data: "Start Call", visibility: true },
    sechduleTime: "Set the call",
    enableStartCallButton: false,
  },
  {
    fileName: "Customer data  217 Sept.csv",
    uploadTimestamp: "15 Sept 2023 09:30 AM",
    uploadedFileName: "",
    download: "",
    adminName: "tks@gmail.com",
    wfName: "CC-100",
    status: "processed",
    callInitiation: { data: "Start Call", visibility: true },
    sechduleTime: "20-Sept-2023 10:30 AM",
    enableStartCallButton: false,
  },
];

export const globalWorkflowConfig = [
  {
    name: "Policy renewal",
    workflowId: "P0001",
    noOfRetries: 2,
    intervalOfRetry: 15,
  },
  {
    name: "Health insurance update intimation",
    workflowId: "P0002",
    noOfRetries: 3,
    intervalOfRetry: 90,
  },
  {
    name: "Debt Collection",
    workflowId: "P0003",
    noOfRetries: 2,
    intervalOfRetry: 60,
  },
];
